/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */
const wasabi = document.createElement('script')
wasabi.setAttribute('src', 'https://sdk.amazonaws.com/js/aws-sdk-2.619.0.min.js')
document.head.appendChild(wasabi)

export async function enviarNuvem(caminhoArquivo, file, storage) {
  return new Promise((resolve, reject) => {
    const s3 = new AWS.S3({
      correctClockSkew: true,
      endpoint: storage.url, // use appropriate endpoint as per region of the bucket
      accessKeyId: storage.chaveAcesso,
      secretAccessKey: storage.chaveSecreta,
      region: storage.region,
      logger: console,
    })

    const uploadRequest = new AWS.S3.ManagedUpload({
      partSize: 15 * 1024 * 1024,
      params: { Bucket: storage.bucketNome, Key: caminhoArquivo, Body: file },
      service: s3,
    })

    uploadRequest.on('httpUploadProgress', event => {
      // eslint-disable-next-line no-mixed-operators
      Math.floor(event.loaded * 100 / event.total)
    })

    uploadRequest.send(err => {
      if (err) {
        reject(new Error(err))
      } else {
        resolve({ sucesso: true })
      }
    })
  })
}
